export default __webpack_public_path__ + "static/michigan-3-533397a785a3ed606756cb3b3755bbee.jpg";